module.exports = __webpack_public_path__ + "static/img/129_TO8_1681.25b4fa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/129_TO8_1681.jpg
// module id = WeiM
// module chunks = 0